import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Tooltip from 'components/application/Tooltip';

import { resourceShape } from 'components/helpers/serialisableResources';
import { personDisplayName } from 'components/helpers/users';

export default function PersonnelShow({
  division,
  isCompact = false,
  personnel,
  roles = [],
  subcontractor,
}) {
  return (
    <div className={classNames('popup__body-show', isCompact && 'tw-pb-0')}>
      <h2
        className={classNames(
          'popup__body-header tw-text-xl tw-font-semibold tw-tracking-tight tw-text-grey-900',
          isCompact ? 'tw-mb-0 tw-h-auto' : (
            'popup__body-header--height-unset truncated-text-container--wrapped truncated-text-container--five-lines truncated-text-container--block tw-max-h-[140px]'
          ),
        )}
      >
        {personDisplayName({ attributes: personnel.attributes })}
      </h2>
      <h3 className='popup__body-header popup__body-header--sub truncated-text-container truncated-text-container--block tw-text-m tw-font-normal tw-tracking-auto'>
        {(subcontractor || division).attributes.name}
      </h3>
      <div
        className={classNames(
          'popup__body-content',
          isCompact ? 'tw-pt-1' : 'tw-pt-0',
        )}
      >
        {roles.length > 0 && (
          <ul
            className={classNames(
              'pill-list',
              isCompact ? 'tw-mt-4' : 'tw-mt-6',
            )}
          >
            {roles.map((role) => (
              <li className='tooltip-parent' key={role.id}>
                <span
                  className={classNames(
                    'pill tw-bg-grey-050',
                    role.attributes.position.length > 30 &&
                      'truncated-text-container',
                  )}
                >
                  {role.attributes.position}
                </span>
                {role.attributes.position.length > 30 && (
                  <Tooltip
                    placement='top'
                    tooltip={role.attributes.position}
                    trigger='hover'
                    type='dark'
                  />
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

PersonnelShow.propTypes = {
  division: resourceShape(['assignableCompany', 'company']),
  isCompact: PropTypes.bool,
  personnel: resourceShape('personnel').isRequired,
  roles: PropTypes.arrayOf(resourceShape('companyRole')),
  subcontractor: resourceShape(['assignableCompany', 'subcontractor']),
};
